import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import { deleteBanner, updateBanner } from "../../../MyApi/banner";
import { getBannerAPI } from "../../../MyApi/banner";
import BannerModal from "../bannermodal";
import Can from "../../../utils/can";
import i18next from "i18next";

const BannersTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bannerModalMode, setBannerModalMode] = useState("create");
  const [bannerId, setBannerId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleShowBanner = (id) => {
    setBannerId(id);
    setBannerModalMode("show");
    setIsModalOpen(true);
  };

  const handleEditBanner = (id) => {
    setBannerId(id);
    setBannerModalMode("edit");
    setIsModalOpen(true);
  };

  const bannersColumns = [
    {
      label: "البانر",
      render: (row) => (
        <img
          src={row.image}
          alt="banner"
          style={{
            width: "120px",
            height: "60px",
            objectFit: "cover",
            borderRadius: "8px",
          }}
        />
      ),
    },
    { label: "العنوان", accessor: "title" },
    { label: "الوصف", accessor: "description" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleShowBanner(row.id)}
          viewPermission={"view_banner"}
          edit={() => handleEditBanner(row.id)}
          editPermission={"update_banner"}
          deleteFn={deleteBanner}
          deletePermission={"delete_banner"}
          id={row.id}
          is_active={row.is_active}
          queryKey={"getBanners"}
           togglePermission={"update_banner"}
                  toggleMutationKey={"toggle_banner"}
                  toggleFn={(id, status) =>
                    updateBanner(
                         id,
                      {
                       is_active: status ,
                        _method: "PUT",
                        lang: i18next.language,
                      },
                   
                    )
                  }
        />
      ),
    },
  ];

  const {
    data: bannersData,
    isLoading: bannersLoading,
    refetch,
    error,
  } = useQuery(["getBanners", currentPage], () => getBannerAPI(currentPage));

  const banners = bannersData?.data?.banners || [];
  const total = bannersData?.data?.pagination?.total || 0;
  const last_page = bannersData?.data?.pagination?.last_page || 0;

  return (
    <>
      <Can permission={"view_banner"}>
        <DataTable
          columns={bannersColumns}
          data={banners}
          title="البانرات"
          actionLabel="إضافة بانر"
          onAddClick={() => {
            setBannerModalMode("create");
            setBannerId(null);
            setIsModalOpen(true);
          }}
          isLoading={bannersLoading}
          createPermission={"create_banner"}
          totalItems={total}
          itemsPerPage={last_page}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          error={error}
          onRetry={() => refetch()}
        />
      </Can>
      <BannerModal
        isOpen={isModalOpen}
        toggle={() => {
          setIsModalOpen(false);
          setBannerModalMode("create");
          setBannerId(null);
        }}
        refetch={refetch}
        mode={bannerModalMode}
        bannerId={bannerId}
      />
    </>
  );
};

export default BannersTab;
